import { Divider, Stack, Text } from '@mantine/core';
import { useEffect } from 'react';
import { useFinancialsStore } from '../../../store/financials-store/financials-store';
import { setTableSelectedYear } from '../../../store/financials-store/financials-store.actions';
import { Button } from '../../../ui-library/button/button';

function Filters({ availableYears }: { availableYears: Set<number> }) {
  const selectedYear = useFinancialsStore((state) => state.table.selectedYear);
  const sortedAvailableYears = Array.from(availableYears).sort((a, b) => b - a);

  useEffect(() => {
    if (!selectedYear && sortedAvailableYears.length) {
      setTableSelectedYear(sortedAvailableYears[0]);
    }
  }, [selectedYear, sortedAvailableYears]);

  return (
    <Stack>
      <Text fw={750}>Years</Text>
      <Divider />
      {(sortedAvailableYears || []).map((year) => (
        <Button
          key={year}
          variant={selectedYear === year ? 'secondary' : 'outline'}
          radius="xl"
          size="xs"
          onClick={() => setTableSelectedYear(year)}
        >
          {year}
        </Button>
      ))}
    </Stack>
  );
}

export { Filters };
